import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/index.css';
import { App } from './App';
import { ConfigErrorScreen } from './routes/ConfigErrorScreen';
import { ConfigError, loadConfig } from './lib/config';
import { initI18n } from './i18n';
import { createSupabaseClient } from './lib/supabase';

const root = createRoot(document.getElementById('root')!);

try {
  const config = loadConfig();
  initI18n(config.defaultLocale);
  const client = createSupabaseClient(config);
  root.render(
    <StrictMode>
      <App client={client} />
    </StrictMode>,
  );
} catch (error) {
  if (!(error instanceof ConfigError)) throw error;
  root.render(<ConfigErrorScreen message={error.message} />);
}
